<template>
  <div class="help padding_top">
    <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
        class="orange">【优惠券管理】</span>，展示【优惠券列表】，子菜单中点击【优惠券】【月卡】【年卡】可切换显示列表
    </p>
    <p><strong>第二步：</strong>在【优惠券】页面，在左上角点击<span class="orange">【新增优惠券】</span>，弹出新增优惠券弹窗</p>
    <img src="../../../assets/doctorImg/couponDoctor_a.png" alt="" height="354">
    <p><strong>第三步：</strong>在【新增优惠券】弹窗中，选择优惠券类型【优惠券】【月卡】【年卡】</p>
    <p>【优惠券类型折扣方式】<br/>
      折率：根据一定百分比给予优惠<br/>
      定额：给予固定金额优惠<br/>
      【月/年类型销售价格+使用限制次数】<br/>
      销售价格：月/年卡的销售价格<br/>
      使用限制次数：指定月/年内的使用次数<br/>
      【开放状态】<br/>
      开放：会展示在用户预约页,任何人可领取<br/>
      不开放：不展示给用户领取，医生可通过分享链接分享给用户领取<br/>
      【开始/结束使用时间 】<br/>
      只有在此时间段内，用户才能使用优惠券<br/>
      【开始/结束领取时间】<br/>
      只有在此时间段内，用户才能领取优惠券<br/>
      按照提示依次填写表单内容，点击<span class="orange">【新增】</span>，新增优惠券成功
    </p>
    <div class="flex">
      <img src="../../../assets/doctorImg/couponDoctor_b.png" alt="" height="572">
      <img src="../../../assets/doctorImg/couponDoctor_c.png" alt="" height="507">
    </div>
    <p><strong>【分享优惠券】</strong></p>
    <p><strong>第一步：</strong>在【优惠券】页面，找到要分享的优惠券条目，点击左侧<span class="orange">【分享】</span>图标，则将优惠券网址复制在剪切板上</p>
    <img src="../../../assets/doctorImg/couponDoctor_d.png" alt="" height="354">
    <p><strong>第二步：</strong>在顶部菜单栏中点击<span class="orange">【患者管理】</span>，进入【患者管理】页面，找到要分享的用户，点击<span
        class="orange">【私信】</span>按钮，进入【聊天页面】
    </p>
    <img src="../../../assets/doctorImg/couponDoctor_e.png" alt="" height="272">
    <p><strong>第三步：</strong>在【聊天页面】，在文字编辑区域，粘贴优惠券网址，并点击<span class="orange">【发送】</span>按钮，则将优惠券成功发送给该用户
    </p>
    <img src="../../../assets/doctorImg/couponDoctor_f.png" alt="" height="539">
  </div>
</template>

<script>
export default {
  name: "couponDoctor",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
